import { Box, Container } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import ErrorMessage from "../components/Common/ErrorMessage";
import LoadingSpinner from "../components/Common/LoadingSpinner";
import PageTitle from "../components/Common/PageTitle";
import MenuPlanResponsive from "../components/MenuPlan/MenuPlanResponsive";
import { RecipeContext } from "../contexts/RecipeContext";
import { flexCenter } from "../styles/commonStyles";

const SharedMenuPlanPage = () => {
  const { t } = useTranslation();
  const { shareId } = useParams();
  const [menuPlan, setMenuPlan] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { recipes = [] } = useContext(RecipeContext);

  useEffect(() => {
    const fetchMenuPlan = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_FIREBASE_FUNCTIONS_URL}/fetchSharedMenuPlan?shareId=${shareId}`);
        const data = await response.json();
        if (data.menuPlan) {
          setMenuPlan(data.menuPlan);
        } else {
          setError("Menu plan not found");
        }
      } catch (err) {
        setError("Error fetching menu plan");
      } finally {
        setLoading(false);
      }
    };

    fetchMenuPlan();
  }, [shareId]);

  if (loading) return <LoadingSpinner />;
  if (error) return <ErrorMessage error={error} />;

  return (
    <Container>
      <Box sx={flexCenter}>
        <PageTitle text={t("sharedWeeklyMenuPlan")} />
      </Box>
      <MenuPlanResponsive menuPlan={menuPlan} recipes={recipes} isReadOnly={true} />
    </Container>
  );
};

export default SharedMenuPlanPage;
